import React, { useEffect, useState } from "react";
import useForm from "../../../../hooks/useForm";
import Button from "../../../form/Button";
import useMutation from "../../../../hooks/useMutation";
import Textarea from "../../../form/Textarea";
import Select from "../../../form/Select";
import { changeStatus, statusList } from "../../../../services/statusService";
import useFetch from "../../../../hooks/useFetch";

const validation = {
  status: { required: true, message: "Status is required" },
};

const ScholarshipStatus = ({
  getResponse = () => {},
  close = () => {},
  data,
}) => {
  const [statusFilters] = useState({
    limit: 10,
    page: 1,
    sortQuery: "-createdAt",
  });

  const { data: status } = useFetch({
    dependencies: ["status", statusFilters],
    fetchFunction: async () => {
      const res = await statusList({ ...statusFilters });
      if (res?.docs?.status === 200) {
        return {
          ...res?.docs,
          data: res?.docs?.data,
        };
      } else {
        if (status?.data?.length > 0) {
          return status;
        } else {
          return res;
        }
      }
    },
  });
  let sortedData = [];
  if (Array.isArray(status?.data) && status?.data.length > 0) {
    sortedData = status.data.slice().sort((a, b) => a.ordering - b.ordering);
  }

  let dropdownData = [];

  if (Array.isArray(sortedData) && sortedData.length > 0) {
    const startIndex = sortedData.findIndex(
      (item) => item?.title === data?.status?.title
    );

    if (startIndex !== -1) {
      const firstTwo = sortedData.slice(0, 2);
      const startItem = sortedData[startIndex];
      const isDuplicate = firstTwo.some(
        (item) => item?.title === startItem?.title
      );

      const additionalItems = isDuplicate
        ? sortedData.slice(startIndex + 1)
        : sortedData.slice(startIndex);

      dropdownData = [...firstTwo, ...additionalItems];
    } else {
      dropdownData = sortedData;
    }
  }

  const {
    values,
    handleChange,
    handleSubmit,
    errors,
    setFieldsValue,
    formValidate,
  } = useForm({ validationRules: validation });

  const {
    mutate,
    error,
    isPending: isLoading,
  } = useMutation({
    mutationFn: async (val) => {
      return await changeStatus({
        ...val,
        ...(data?._id && { ids: [data?._id] }),
        userId: data?.userId,
        formId: data?.applicationFormId,
        scholarshipId: data?.scholarshipId,
      });
    },
    onSuccess: (res) => {
      getResponse(res);
      close();
      return res;
    },
    onError: (error) => {
      console.log(error);
    },
  });

  useEffect(() => {
    if (data?.statusDetails?._id) {
      setFieldsValue({
        status: data?.statusDetails?._id,
        comment: data?.statusDetails?.description || "",
      });
    }
  }, [data?.statusDetails?._id]);

  return (
    <form onSubmit={(event) => handleSubmit(event, mutate)}>
      <div className="grid grid-cols-4 gap-x-4 gap-y-4">
        <div className="relative col-span-4">
          <Select
            label={"Application Status"}
            placeholder="Select Application Status"
            selectedValue={values?.status}
            dropdownData={(dropdownData || [])?.map((item) => ({
              value: String(item?._id),
              name: item?.title?.replace(/_/g, " ") || "-",
            }))}
            setSelectedValue={(val) => {
              const selectedStatus = dropdownData.find(
                (item) => String(item._id) === String(val)
              );

              setFieldsValue({
                status: val,
                comment: selectedStatus?.description || "",
              });
            }}
            {...formValidate(errors, "status")}
          />
        </div>

        <div className="relative col-span-4">
          <Textarea
            inputName={"comment"}
            label={"Description"}
            inputPlaceholder={"Enter Your Description"}
            inputValue={values?.comment || ""}
            onChange={handleChange}
            {...formValidate(errors, "comment")}
          />
        </div>
      </div>

      <div className="relative col-span-4 mt-5">
        <div className="flex items-center justify-center gap-4">
          <Button
            buttonType="submit"
            buttonLabel={"Submit"}
            buttonClasses={
              "!rounded-full !px-8 !h-12 !border !border-chestnut-rose !bg-transparent !text-chestnut-rose hover:!bg-chestnut-rose hover:!text-white"
            }
            buttonLabelClasses={"mx-auto"}
            {...(isLoading && {
              loading: true,
              buttonIconPosition: "left",
              isDisable: true,
            })}
          />
          <Button
            buttonLabel={"Cancel"}
            buttonClasses={
              "!rounded-full !px-8 !h-12 !border !border-chestnut-rose !bg-transparent !text-chestnut-rose hover:!bg-chestnut-rose hover:!text-white"
            }
            buttonLabelClasses={"mx-auto"}
            buttonFunction={close}
          />
        </div>
      </div>
    </form>
  );
};

export default ScholarshipStatus;
